import { HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '../../environments/environment';

export const ApiHttpInterceptorFn: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> => {
  const endpoint = req.url;

  // Only prepend the base URL to requests with an absolute URL
  if (!endpoint.startsWith('/')) {
    return next(req);
  }

  let baseUrl = environment.apiUrl;

  if (baseUrl.endsWith('/')) {
    baseUrl = baseUrl.slice(0, -1);
  }

  const fullUrl = `${baseUrl}${endpoint}`;
  const modifiedRequest = req.clone({ url: fullUrl });

  return next(modifiedRequest);
};
